import InboxSerializer from '../serializers/InboxSerializers';
import {CompanyMatches} from '../types/InboxTypes';

import {getPaginatedMatches} from '../../../../../lib/api/v1';
import {ApiResponse, ApiResponseError} from '../../../../../lib/api/v1/types';
import {forceLogout} from '../../../../../services/auth-service';

export class InboxService {
  async getPaginatedData(url: string): Promise<ApiResponse<CompanyMatches>> {
    try {
      const response = await getPaginatedMatches(url);
      const body = await response.json();
      if (response.ok) {
        const matches = InboxSerializer.toObjectPaginated(body);
        return {
          ok: true,
          data: matches,
          error: undefined,
        };
      }

      if (response.status === 401) {
        forceLogout();
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
